import HadronError from './src/errorHandler';

export { HadronError as default };
